var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4383 4.6211H22.6895V2.87252C22.6894 2.56246 22.4379 2.311 22.1278 2.31082H20.3789V0.5617C20.3789 0.251466 20.1274 0 19.8172 0H0.5617C0.251466 0 0 0.251466 0 0.5617V19.8172C0 20.1274 0.251466 20.3789 0.5617 20.3789H2.311V22.1275C2.311 22.4375 2.56247 22.689 2.87252 22.6892H4.6211V24.4385V24.4383C4.6211 24.7485 4.87257 25 5.18281 25H24.4383C24.7485 25 25 24.7485 25 24.4383V5.18281C25 4.87257 24.7485 4.62111 24.4383 4.62111V4.6211ZM2.31091 2.87252V19.2557H1.12318V1.12295H19.2559V2.31069H2.87274C2.56268 2.31069 2.31122 2.56215 2.31122 2.87221L2.31091 2.87252ZM3.43413 21.566V3.43413H21.5664V4.62101H5.18281C4.87257 4.62101 4.6211 4.87248 4.6211 5.18254V21.5657L3.43413 21.566ZM23.8767 23.877H5.74397V5.74424H23.8767V23.877Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5835 18.9519C12.6892 19.0587 12.8331 19.1187 12.9832 19.1187H13.0008C13.1569 19.1138 13.3039 19.044 13.4066 18.9265L20.1192 11.2242C20.3192 10.99 20.2934 10.6383 20.0613 10.4358C19.829 10.2333 19.4771 10.2555 19.2722 10.4857L12.9574 17.7313L10.4673 15.2105C10.2494 14.9897 9.89358 14.9876 9.67282 15.2058C9.45205 15.4239 9.44996 15.7797 9.66811 16.0003L12.5835 18.9519Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPage);
export default __webpack_public_path__ + "static/media/check-page.eabe4a08.svg";
export { ForwardRef as ReactComponent };